import useFeatureFlags from 'hooks/useFeatureFlags'

// A misspelt flag name reads as off forever, so it is declared once.
const INCIDENT_CASE_V2_FLAG = 'incident_case_v2'

/** Whether this home gets the v2 case; callers must branch on `isLoading`. */
const useIncidentCaseV2 = (): { isEnabled: boolean; isLoading: boolean } => {
  const { data, isLoading } = useFeatureFlags({
    flagNames: [INCIDENT_CASE_V2_FLAG]
  })

  return {
    isEnabled: Boolean(data[INCIDENT_CASE_V2_FLAG]?.enabled),
    isLoading
  }
}

export default useIncidentCaseV2
